module.exports = __webpack_public_path__ + "media/images/logo2-2ac3ac960e17ea8d4b53f065b8de32e2.png";